
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './BRAIN-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.document_$external_prop_getter' : (_this) => _this.document,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.hostname_$external_prop_getter' : (_this) => _this.hostname,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.title_$external_prop_getter' : (_this) => _this.title,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.onhashchange_$external_prop_setter' : (_this, v) => _this.onhashchange = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.back_$external_fun' : (_this, ) => _this.back(),
    'org.w3c.dom.forward_$external_fun' : (_this, ) => _this.forward(),
    'org.w3c.dom.replaceState_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.replaceState(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.childElementCount_$external_prop_getter' : (_this) => _this.childElementCount,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.clear_$external_fun' : (_this, ) => _this.clear(),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.HTMLIFrameElement_$external_class_instanceof' : (x) => x instanceof HTMLIFrameElement,
    'org.w3c.dom.HTMLIFrameElement_$external_class_get' : () => HTMLIFrameElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.url.URL_$external_fun' : (p0, p1, isDefault0) => new URL(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.url.searchParams_$external_prop_getter' : (_this) => _this.searchParams,
    'org.w3c.dom.url.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.node.requireExists' : () => typeof require === 'function',
    'kotlinx.io.node.requireModule' : (mod) => {
         try {
             let m = require(mod);
             if (m) return m;
             return null;
         } catch (e) {
             return null;
         }
     },
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
    'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'org.kotlincrypto.random.internal.isNodeJs' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'org.kotlincrypto.random.internal.cryptoNode' : () => eval('require')('crypto'),
    'org.kotlincrypto.random.internal.cryptoBrowser' : () => (window ? (window.crypto ? window.crypto : window.msCrypto) : self.crypto),
    'org.kotlincrypto.random.internal.uint8ArrayGet' : (obj, index) => { return obj[index]; },
    'org.kotlincrypto.random.internal.uint8ArraySet' : (obj, index, value) => { obj[index] = value; },
    'org.kotlincrypto.random.internal.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
    'org.kotlincrypto.random.internal.randomFillSync_$external_fun' : (_this, p0) => _this.randomFillSync(p0),
    'org.kotlincrypto.random.internal.Crypto_$external_class_instanceof' : (x) => x instanceof Crypto,
    'org.kotlincrypto.random.internal.Crypto_$external_class_get' : () => Crypto,
    'org.kotlincrypto.random.internal.Uint8Array_$external_fun' : (p0) => new Uint8Array(p0),
    'org.kotlincrypto.random.internal.subarray_$external_fun' : (_this, p0, p1) => _this.subarray(p0, p1),
    'com.mico.learn.core.audio.jsIsPlaying' : (audio) => { return !audio.paused; },
    'com.mico.learn.core.audio.jsStop' : (audio) => { audio.onended=null; audio.onerror=null; audio.pause(); audio.currentTime = 0; },
    'com.mico.learn.core.audio.jsNewAudio' : (src) => { var a = new Audio(src); return a; },
    'com.mico.learn.core.audio.jsStartAudio' : (audio, speed, done) => { audio.playbackRate=speed; audio.onended=done; audio.onerror=done; audio.play().catch(done); },
    'com.mico.learn.core.audio.jsPlay' : (audio) => { audio.currentTime = 0; audio.play().catch(function(){}); },
    'com.mico.learn.core.audio.jsIsPlaying_1' : () => { return !!window._micoAudioPlaying || window.speechSynthesis.speaking; },
    'com.mico.learn.core.audio.jsPlayMp3Base64' : (base64) => { if (window._micoAudio) { window._micoAudio.pause(); window._micoAudio.currentTime = 0; } var audio = new Audio('data:audio/mpeg;base64,' + base64); window._micoAudio = audio; window._micoAudioPlaying = true; audio.onended = function() { window._micoAudioPlaying = false; }; audio.onerror = function() { window._micoAudioPlaying = false; }; audio.play().catch(function() { window._micoAudioPlaying = false; }); },
    'com.mico.learn.core.audio.jsSpeakFallback' : (text, lang) => { var u = new SpeechSynthesisUtterance(text); u.lang = lang; window.speechSynthesis.speak(u); },
    'com.mico.learn.core.audio.jsStopAll' : () => { if (window._micoAudio) { window._micoAudio.pause(); window._micoAudio.currentTime = 0; window._micoAudio = null; } window._micoAudioPlaying = false; window.speechSynthesis.cancel(); },
    'com.mico.learn.core.auth.readLocationHash' : () => window.location.hash,
    'com.mico.learn.core.auth.clearLocationFragment' : () => history.replaceState(history.state, '', window.location.pathname + window.location.search),
    'com.mico.learn.core.auth.readLocationOrigin' : () => window.location.origin,
    'com.mico.learn.core.auth.readLocationPathAndSearch' : () => window.location.pathname + window.location.search,
    'com.mico.learn.core.platform.jsClipboardWrite' : (text, subject) => { try { navigator.clipboard.writeText(text); } catch(e) {} },
    'com.mico.learn.core.platform.jsShowToast' : (msg) => {
        var d = document.createElement('div');
        d.textContent = msg;
        d.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.8);color:#fff;padding:12px 24px;border-radius:8px;font-size:14px;z-index:9999;transition:opacity 0.3s';
        document.body.appendChild(d);
        setTimeout(function(){d.style.opacity='0';setTimeout(function(){d.remove()},300)},2000);
    },
    'com.mico.learn.core.platform.jsDateNow' : () => Date.now(),
    'com.mico.learn.core.ui.components.jsRegisterPdfDocument' : 
    (base64Pdf) => {
        return new Promise(async (resolve) => {
            try {
                const binary = atob(base64Pdf);
                const bytes = new Uint8Array(binary.length);
                for (let i = 0; i < binary.length; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                const pdf = await pdfjsLib.getDocument({ data: bytes }).promise;
                window.__micoPdfDocs = window.__micoPdfDocs || {};
                const docId = 'pdf_' + Math.random().toString(36).slice(2);
                window.__micoPdfDocs[docId] = pdf;
                resolve(JSON.stringify({ docId, pageCount: pdf.numPages }));
            } catch (e) {
                console.error('[PDF] Error registering document:', e);
                resolve('{}');
            }
        });
    }
    ,
    'com.mico.learn.core.ui.components.jsRenderPdfPageFromDocument' : 
    (docId, pageNum, maxWidth) => {
        return new Promise(async (resolve) => {
            try {
                const docs = window.__micoPdfDocs || {};
                const pdf = docs[docId];
                if (!pdf) {
                    resolve('');
                    return;
                }

                const safePage = Math.max(1, Math.min(pageNum, pdf.numPages));
                const page = await pdf.getPage(safePage);
                const viewport = page.getViewport({ scale: 1.0 });
                const scale = maxWidth / viewport.width;
                const scaledViewport = page.getViewport({ scale });

                const canvas = document.createElement('canvas');
                canvas.width = scaledViewport.width;
                canvas.height = scaledViewport.height;
                const ctx = canvas.getContext('2d');

                await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;

                const dataUrl = canvas.toDataURL('image/png');
                resolve(dataUrl.split(',')[1] || '');
            } catch (e) {
                console.error('[PDF] Error rendering registered page:', e);
                resolve('');
            }
        });
    }
    ,
    'com.mico.learn.core.ui.components.jsReleasePdfDocument' : 
    (docId) => {
        try {
            if (window.__micoPdfDocs && window.__micoPdfDocs[docId]) {
                delete window.__micoPdfDocs[docId];
            }
        } catch (e) {
            console.warn('[PDF] Error releasing document:', e);
        }
    }
    ,
    'com.mico.learn.core.ui.platform.jsReadFileBase64' : 
    (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                const bytes = new Uint8Array(reader.result);
                let binary = '';
                for (let i = 0; i < bytes.length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                resolve(btoa(binary));
            };
            reader.onerror = () => resolve('');
            reader.readAsArrayBuffer(file);
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsFetchBase64' : (url, auth) => new Promise((resolve, reject) => {
        var opts = auth ? { headers: { 'Authorization': auth } } : undefined;
        fetch(url, opts).then(function(r) {
            if (!r.ok) { reject(new Error('http ' + r.status)); return null; }
            return r.arrayBuffer();
        }).then(function(buf) {
            if (!buf) return;
            var bytes = new Uint8Array(buf);
            var s = '';
            var CH = 0x8000;
            for (var i = 0; i < bytes.length; i += CH) {
                s += String.fromCharCode.apply(null, bytes.subarray(i, i + CH));
            }
            resolve(btoa(s));
        }).catch(function(e) { reject(e); });
    }),
    'com.mico.learn.core.ui.platform.jsPickAudioFile' : 
    () => {
        return new Promise((resolve) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'audio/*,.mp3,.wav,.ogg,.aac,.flac,.m4a,.webm';
            input.style.display = 'none';
            document.body.appendChild(input);

            input.addEventListener('change', () => {
                const file = input.files && input.files[0];
                if (!file) {
                    document.body.removeChild(input);
                    resolve('');
                    return;
                }
                // Store file globally for later access
                window._lastPickedAudioFile = file;
                const info = JSON.stringify({
                    name: file.name,
                    type: file.type || 'audio/mpeg',
                    size: file.size
                });
                document.body.removeChild(input);
                resolve(info);
            });

            input.addEventListener('cancel', () => {
                document.body.removeChild(input);
                resolve('');
            });

            input.click();
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsGetAudioDuration' : 
    () => {
        return new Promise((resolve) => {
            const file = window._lastPickedAudioFile;
            if (!file) { resolve(0); return; }
            const audio = new Audio();
            audio.preload = 'metadata';
            const objectUrl = URL.createObjectURL(file);
            audio.onloadedmetadata = () => {
                const duration = Math.round(audio.duration);
                URL.revokeObjectURL(objectUrl);
                resolve(duration);
            };
            audio.onerror = () => {
                URL.revokeObjectURL(objectUrl);
                // Fallback: estimate from file size (rough: 16kbps)
                resolve(Math.round(file.size / 16000));
            };
            audio.src = objectUrl;
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsReadAudioAsBase64' : 
    () => {
        return new Promise((resolve) => {
            const file = window._lastPickedAudioFile;
            if (!file) { resolve(''); return; }
            const reader = new FileReader();
            reader.onload = () => {
                const bytes = new Uint8Array(reader.result);
                let binary = '';
                for (let i = 0; i < bytes.length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                resolve(btoa(binary));
            };
            reader.onerror = () => resolve('');
            reader.readAsArrayBuffer(file);
        });
    }
    ,
    'com.mico.learn.core.ui.platform.eLaVoce' : (e) => e.state === 'mico-voce',
    'com.mico.learn.core.ui.platform.rimettiIndirizzo' : (url) => history.replaceState(history.state, '', url),
    'com.mico.learn.core.ui.platform.conGesto' : () => !navigator.userActivation || navigator.userActivation.isActive,
    'com.mico.learn.core.ui.platform.aggiungiVoce' : () => history.pushState('mico-voce', '', location.href),
    'com.mico.learn.core.ui.platform.allaProssimaInterazione' : (fatto) => {
            const f = () => {
                window.removeEventListener('click', f, true);
                window.removeEventListener('keydown', f, true);
                fatto();
            };
            window.addEventListener('click', f, true);
            window.addEventListener('keydown', f, true);
        },
    'com.mico.learn.core.ui.platform.navigatorMaxTouchPoints' : () => navigator.maxTouchPoints || 0,
    'com.mico.learn.core.ui.platform.jsPickFiles' : 
    (accept, multiple) => {
        return new Promise((resolve) => {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = accept;
            input.multiple = multiple;
            input.style.display = 'none';
            document.body.appendChild(input);

            input.addEventListener('change', () => {
                const files = input.files;
                const result = [];
                for (let i = 0; i < files.length; i++) {
                    const f = files[i];
                    result.push({
                        name: f.name,
                        type: f.type || '',
                        size: f.size
                    });
                }
                // Store files globally so we can access them from Kotlin
                window._lastPickedFiles = files;
                document.body.removeChild(input);
                resolve(JSON.stringify(result));
            });

            // Handle cancel (no file selected)
            input.addEventListener('cancel', () => {
                document.body.removeChild(input);
                resolve('[]');
            });

            // Fallback: if user clicks away without selecting
            const onFocus = () => {
                setTimeout(() => {
                    if (input.files && input.files.length === 0) {
                        // User cancelled
                    }
                    window.removeEventListener('focus', onFocus);
                }, 300);
            };
            window.addEventListener('focus', onFocus);

            input.click();
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsGetPickedFile' : 
    (index) => {
        const files = window._lastPickedFiles;
        if (!files || index >= files.length) return null;
        return files[index];
    }
    ,
    'com.mico.learn.core.ui.platform.jsReadFileAsBase64Web' : (file) => {
        return new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onload = function() {
                var bytes = new Uint8Array(reader.result);
                var binary = '';
                for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
                resolve(btoa(binary));
            };
            reader.onerror = function() { resolve(''); };
            reader.readAsArrayBuffer(file);
        });
    },
    'com.mico.learn.core.ui.platform.jsScegliMedia' : 
    (accept, multipli, latoMassimo, qualita) => new Promise((resolve) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = accept;
        input.multiple = multipli;
        input.style.display = 'none';
        document.body.appendChild(input);
        let finito = false;
        const chiudi = (json) => { if (finito) return; finito = true; input.remove(); resolve(json); };
        const inBase64 = (blob) => new Promise((ok) => {
            const lettore = new FileReader();
            lettore.onload = () => { const s = String(lettore.result); ok(s.slice(s.indexOf(',') + 1)); };
            lettore.onerror = () => ok('');
            lettore.readAsDataURL(blob);
        });
        const ridotta = async (file) => {
            try {
                const bmp = await createImageBitmap(file);
                const f = Math.min(1, latoMassimo / Math.max(bmp.width, bmp.height));
                const tela = document.createElement('canvas');
                tela.width = Math.max(1, Math.round(bmp.width * f));
                tela.height = Math.max(1, Math.round(bmp.height * f));
                const g = tela.getContext('2d');
                g.fillStyle = '#ffffff';
                g.fillRect(0, 0, tela.width, tela.height);
                g.drawImage(bmp, 0, 0, tela.width, tela.height);
                bmp.close();
                const jpeg = await new Promise((ok) => tela.toBlob(ok, 'image/jpeg', qualita));
                return jpeg ? await inBase64(jpeg) : '';
            } catch (e) { return ''; }
        };
        input.addEventListener('change', async () => {
            const scelti = [];
            for (const file of Array.from(input.files || [])) {
                const immagine = (file.type || '').startsWith('image/');
                const jpeg = immagine ? await ridotta(file) : '';
                scelti.push({
                    nome: file.name,
                    tipo: jpeg ? 'image/jpeg' : (file.type || ''),
                    immagine: immagine,
                    dati: jpeg || await inBase64(file)
                });
            }
            chiudi(JSON.stringify(scelti));
        });
        input.addEventListener('cancel', () => chiudi('[]'));
        input.click();
    })
    ,
    'com.mico.learn.core.ui.platform.jsOpenUrlPreferNewTab' : (url) => {
            try {
                const w = window.open(url, '_blank');
                if (w) {
                    try { w.opener = null; } catch (e) {}
                    return true;
                }
            } catch (e) {}
            window.location.href = url;
            return false;
        },
    'com.mico.learn.core.ui.platform.jsGetPdfPageCount' : 
    (file) => {
        return new Promise(async (resolve) => {
            try {
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                resolve(pdf.numPages);
            } catch (e) {
                console.error('[PDF] Error getting page count:', e);
                resolve(0);
            }
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsRenderPdfPage' : 
    (file, pageNum, maxWidth) => {
        return new Promise(async (resolve) => {
            try {
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                const page = await pdf.getPage(pageNum);

                const viewport = page.getViewport({ scale: 1.0 });
                const scale = maxWidth / viewport.width;
                const scaledViewport = page.getViewport({ scale: scale });

                const canvas = document.createElement('canvas');
                canvas.width = scaledViewport.width;
                canvas.height = scaledViewport.height;
                const ctx = canvas.getContext('2d');

                await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;

                // Convert to PNG base64
                const dataUrl = canvas.toDataURL('image/png');
                const base64 = dataUrl.split(',')[1];
                resolve(base64);
            } catch (e) {
                console.error('[PDF] Error rendering page ' + pageNum + ':', e);
                resolve('');
            }
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsExtractTextPaged' : (file, pagesJson) => window.extractTextFromPdfPaged ? window.extractTextFromPdfPaged(file, pagesJson) : Promise.resolve('{}'),
    'com.mico.learn.core.ui.platform.jsExtractText' : (file, pagesJson) => window.extractTextFromPdfPages(file, pagesJson),
    'com.mico.learn.core.ui.platform.jsGenerateProjectThumbnail' : (kind, content, onDone) => {
        var src = kind === 'sheet' ? '/sheet-editor/index.html' : '/tiptap-editor/index.html';
        var iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:fixed;left:-10000px;top:0;width:900px;height:700px;border:none;';
        iframe.src = src;
        var done = false;
        var finish = function(dataUrl) {
            if (done) return;
            done = true;
            window.removeEventListener('message', onMsg);
            try { iframe.remove(); } catch (e) {}
            onDone(dataUrl == null ? null : dataUrl);
        };
        var onMsg = function(e) {
            if (e.source !== iframe.contentWindow || !e.data) return;
            var t = e.data.type;
            if (t === 'THUMBNAIL' && e.data.payload && e.data.payload.dataUrl) {
                finish(e.data.payload.dataUrl);
            }
        };
        window.addEventListener('message', onMsg);
        document.documentElement.appendChild(iframe);

        var deadline = Date.now() + 45000;
        var started = false;
        var tick = function() {
            if (done) return;
            if (Date.now() > deadline) { finish(null); return; }
            var w = iframe.contentWindow;
            try {
                if (!started) {
                    if (kind === 'sheet' && w && w.SheetEditor && typeof w.SheetEditor.loadJson === 'function') {
                        started = true;
                        w.SheetEditor.loadJson(content);
                        setTimeout(function() {
                            if (done) return;
                            try { w.SheetEditor.generateThumbnail(420); } catch (e) { finish(null); }
                        }, 2500);
                    } else if (kind !== 'sheet' && w && w.TiptapEditor && typeof w.TiptapEditor.loadHTML === 'function') {
                        started = true;
                        w.TiptapEditor.loadHTML(content);
                        setTimeout(function() {
                            if (done) return;
                            try { w.TiptapEditor.generateThumbnail(420); } catch (e) { finish(null); }
                        }, 1500);
                    }
                }
            } catch (e) { finish(null); return; }
            setTimeout(tick, 250);
        };
        setTimeout(tick, 250);
    },
    'com.mico.learn.core.ui.platform.jsIndirizzo' : () => window.location.pathname + window.location.search,
    'com.mico.learn.core.ui.platform.jsScrivi' : (url) => {
            if (window.location.pathname + window.location.search !== url) {
                // Lo stato della voce resta: è dove l'indietro del browser tiene il suo segno (IndietroDelBrowser).
                history.replaceState(history.state, '', url);
            }
        },
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'com.mico.learn.features.canvaseditor.webview.jsCreateEditorIframe' : (id, src) => {
        if (document.getElementById(id)) return;
        var iframe = document.createElement('iframe');
        iframe.id = id;
        iframe.src = src;
        iframe.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;border:none;' +
            'z-index:50;background:#f1f1f1;transition:opacity 0.2s;';
        iframe.allow = 'clipboard-write';
        // Append a <html>, NON a <body>: nella pagina wasm il body non viene
        // renderizzato (Compose monta il proprio layer altrove) e qualsiasi figlio
        // del body resta con layout 0×0 → iframe invisibile e viewport interno 0.
        document.documentElement.appendChild(iframe);

        // Coda messaggi per Kotlin
        window.__ceMessageQueue = [];

        // Ascolta postMessage dall'iframe.
        // Formato: method + U+0001 + data (NIENTE JSON.stringify del wrapper: il
        // vecchio doppio-encoding produceva escape \" che il parser Kotlin troncava
        // alla prima quote → onSelectionChanged/onPageChanged/onThumbnailUpdate/
        // onCanvasStateChanged arrivavano SEMPRE vuoti sul web).
        window.__ceMessageListener = function(e) {
            if (e.data && e.data.source === 'ce-bridge') {
                var d = e.data.data == null ? '' : String(e.data.data);
                window.__ceMessageQueue.push(String(e.data.method) + '\u0001' + d);
            }
        };
        window.addEventListener('message', window.__ceMessageListener);

        // Quando l'iframe è caricato, inietta il bridge
        iframe.onload = function() {
            try {
                iframe.contentWindow.eval(
                    "window.CanvasBridge = {};" +
                    "['onWebViewReady','onSave','onExport','onPageChanged','onPageData'," +
                    "'onSelectionChanged','onSelectionCleared','onThumbnailUpdate'," +
                    "'onFontPreviews','onTextStylePreviews','onLayersList','onLayerThumb'," +
                    "'onCanvasStateChanged','onPageAnimationsDone','onPlayerTap','onCommandResult'," +
                    "'onObjectModified','onDragModeChanged','onActionBarMore','requestKeyboard','log'" +
                    "].forEach(function(m){" +
                    "  window.CanvasBridge[m] = function(data){" +
                    "    if(m==='onWebViewReady')window.__ceReadySent=true;" +
                    "    parent.postMessage({source:'ce-bridge', method:m, data:data}, '*');" +
                    "  };" +
                    "});"
                );
                console.log('[CE iframe] bridge injected');
                // FAB AI dentro l'iframe: sul web il FAB Compose è coperto
                // dall'iframe, quindi il pulsante vive nel documento dell'editor
                // e passa il click al Kotlin via bridge.
                try {
                    var fdoc = iframe.contentDocument;
                    if (fdoc && !fdoc.getElementById('mico-ai-fab')) {
                        var fab = fdoc.createElement('div');
                        fab.id = 'mico-ai-fab';
                        fab.textContent = '✨';
                        fab.style.cssText = 'position:fixed;right:18px;bottom:18px;width:52px;height:52px;' +
                            'border-radius:50%;background:#7A63C9;color:#fff;display:flex;align-items:center;' +
                            'justify-content:center;font-size:22px;cursor:pointer;z-index:99999;' +
                            'box-shadow:0 4px 12px rgba(0,0,0,.25);user-select:none;';
                        fab.onclick = function() {
                            parent.postMessage({source:'ce-bridge', method:'onAiFabClick', data:''}, '*');
                        };
                        fdoc.body.appendChild(fab);
                    }
                } catch(e) {}
                // Forza resize dopo che il layout si è stabilizzato
                setTimeout(function() {
                    try {
                        iframe.contentWindow.eval(
                            "var ws=document.querySelector('#workspace');" +
                            "var w=window.innerWidth||document.documentElement.clientWidth||384;" +
                            "var h=window.innerHeight||document.documentElement.clientHeight||600;" +
                            "if(ws){ws.style.width=w+'px';ws.style.height=h+'px';}" +
                            "if(window.CE)window.CE.zoomFit();" +
                            // Re-emit di sicurezza soltanto DOPO CE._initPages. La sola
                            // presenza di window.CE non basta: il bootstrap headless lo
                            // espone prima del suo blocco ready e un init KMP anticipato
                            // verrebbe poi sovrascritto dalla pagina editor iniziale.
                            "var notifyReady=function(deadline){" +
                            "if(window.CE&&typeof window.CE.getPageCount==='function'&&window.CE.getPageCount()>0){" +
                            // __ceReadySent only proves that the iframe attempted a
                            // postMessage; it cannot prove that the parent received
                            // it. Kotlin's readyHandled flag safely deduplicates this
                            // one fallback acknowledgement.
                            "window.CanvasBridge.onWebViewReady();return;}" +
                            // Keep the fallback aligned with the KMP player timeout.
                            // The native ready event normally wins; this only covers
                            // an event lost while the bridge was being injected.
                            "if(Date.now()<deadline)setTimeout(function(){notifyReady(deadline);},50);" +
                            "};notifyReady(Date.now()+44000);"
                        );
                    } catch(ex) {}
                }, 200);
            } catch(e) {
                console.error('[CE iframe] bridge inject error:', e);
            }
        };

        console.log('[CE iframe] created:', src);
    },
    'com.mico.learn.features.canvaseditor.webview.jsRemoveEditorIframe' : (id) => {
        var iframe = document.getElementById(id);
        if (iframe) iframe.remove();
        if (window.__ceMessageListener) {
            window.removeEventListener('message', window.__ceMessageListener);
            window.__ceMessageListener = null;
        }
        window.__ceMessageQueue = [];
    },
    'com.mico.learn.features.canvaseditor.webview.jsSetEditorIframeOverlay' : (id, overlayActive, popupActive, inputBlocked) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        if (popupActive) {
            iframe.style.opacity = '0';
        } else if (overlayActive) {
            iframe.style.opacity = '0.15';
        } else {
            iframe.style.opacity = '1';
        }
        iframe.style.pointerEvents = (overlayActive || popupActive || inputBlocked) ? 'none' : 'auto';
    },
    'com.mico.learn.features.canvaseditor.webview.jsDrainCeMessages' : () => {
        if (!window.__ceMessageQueue || window.__ceMessageQueue.length === 0) return '';
        var msgs = window.__ceMessageQueue.splice(0, window.__ceMessageQueue.length);
        return msgs.join('\0');
    },
    'com.mico.learn.features.canvaseditor.webview.jsEvalInEditorIframe' : (js) => {
        var iframe = document.getElementById('ce-editor-frame');
        if (iframe && iframe.contentWindow) {
            try { iframe.contentWindow.eval(js); }
            catch(e) { console.error('[CE eval]', e); }
        }
    },
    'com.mico.learn.features.canvaseditor.webview.jsSetEditorIframeClipHole' : (id, holesJson) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        var holes = [];
        try { holes = JSON.parse(holesJson); } catch (error) {}
        if (!Array.isArray(holes)) holes = [];
        holes = holes.filter(function(hole) {
            return hole && ['x','y','w','h','r'].every(function(k) { return Number.isFinite(hole[k]); }) && hole.w > 0 && hole.h > 0;
        });
        if (!holes.length) {
            // MAI 'none' e MAI un clip rettangolare pieno: solo un clip
            // NON-rettangolare toglie all'iframe il ruolo di occluder — senza,
            // il compositor Chrome culla il canvas wasm sotto e la fascia della
            // top bar resta non dipinta (collaudo 2026-07-18). Micro-buco 1px
            // nell'angolo: invisibile e senza effetti sui click.
            var iw = iframe.offsetWidth, ih = iframe.offsetHeight;
            iframe.style.clipPath = 'path("M 0 0 H ' + iw + ' V ' + ih + ' H 0 Z ' +
                'M 0 0 V 1 H 1 V 0 Z")';
            return;
        }
        var rect = iframe.getBoundingClientRect();
        var W = Math.ceil(rect.width), H = Math.ceil(rect.height);
        var p = 'M0 0H' + W + 'V' + H + 'H0Z';
        holes.forEach(function(hole) {
            var x = hole.x, y = hole.y, w = hole.w, h = hole.h;
            var rr = Math.max(0, Math.min(hole.r, w / 2, h / 2));
            var x2 = x + w, y2 = y + h;
            p += 'M' + (x + rr) + ' ' + y +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x + ' ' + (y + rr) +
            'V' + (y2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x + rr) + ' ' + y2 +
            'H' + (x2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x2 + ' ' + (y2 - rr) +
            'V' + (y + rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x2 - rr) + ' ' + y + 'Z';
        });
        iframe.style.clipPath = 'path("' + p + '")';
    },
    'com.mico.learn.features.canvaseditor.webview.jsUpdateEditorIframePosition' : (id, x, y, w, h) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        iframe.style.left = x + 'px';
        iframe.style.top = y + 'px';
        iframe.style.width = w + 'px';
        iframe.style.height = h + 'px';
        var pos = x + ',' + y + ' ' + w + 'x' + h;
        if (window.__ceLastPos !== pos) {
            window.__ceLastPos = pos;
            console.log('[CE iframe] pos: ' + pos);
        }
        // Kick: se l'headless si è inizializzato quando l'iframe non aveva ancora
        // layout (fabric 0×0, zoom 0), ridimensiona workspace+canvas e rifai lo
        // zoomFit con le dimensioni note. Idempotente: scatta solo con canvas a 0.
        if (w > 0 && h > 0) {
            try {
                var cw = iframe.contentWindow;
                var fc = cw && cw.__ceGetFabricCanvas ? cw.__ceGetFabricCanvas() : null;
                if (fc && (fc.getWidth() === 0 || fc.getHeight() === 0)) {
                    var ws = cw.document.querySelector('#workspace');
                    if (ws) { ws.style.width = w + 'px'; ws.style.height = h + 'px'; }
                    fc.setDimensions({ width: w, height: h });
                    if (cw.CE) cw.CE.zoomFit();
                    console.log('[CE iframe] kicked inner canvas to ' + w + 'x' + h);
                }
            } catch (e) {}
            // Resize: quando cambia la taglia dell'iframe (dock/pannelli laterali,
            // resize finestra) il fabric interno va ridimensionato. Regole:
            // - MAI durante un drag/trasformazione (setDimensions ucciderebbe il
            //   gesto: drag congelato che "salta" allo stato finale) → rinvia;
            // - niente jitter sub-2px (le ricomposizioni Compose oscillano di frazioni);
            // - conserva zoom e ricentra (stile Canva) invece di zoomFit, che
            //   resettava la vista dell'utente a ogni variazione delle barre.
            var size = w + 'x' + h;
            if (window.__ceLastSize !== size) {
                window.__ceLastSize = size;
                if (window.__ceResizeTimer) clearTimeout(window.__ceResizeTimer);
                var doCeResize = function() {
                    window.__ceResizeTimer = null;
                    try {
                        var f = document.getElementById(id);
                        if (!f) return;
                        var cw2 = f.contentWindow;
                        var fc2 = cw2 && cw2.__ceGetFabricCanvas ? cw2.__ceGetFabricCanvas() : null;
                        if (!fc2) return;
                        if (fc2._currentTransform) {
                            window.__ceResizeTimer = setTimeout(doCeResize, 250);
                            return;
                        }
                        var w2 = cw2.innerWidth || 0;
                        var h2 = cw2.innerHeight || 0;
                        if (w2 <= 0 || h2 <= 0) return;
                        var ow = fc2.getWidth();
                        var oh = fc2.getHeight();
                        if (Math.abs(ow - w2) < 2 && Math.abs(oh - h2) < 2) return;
                        var ws2 = cw2.document.querySelector('#workspace');
                        if (ws2) { ws2.style.width = w2 + 'px'; ws2.style.height = h2 + 'px'; }
                        var vpt = fc2.viewportTransform ? fc2.viewportTransform.slice() : null;
                        fc2.setDimensions({ width: w2, height: h2 });
                        // Il player è read-only e deve restare immersivo quando il
                        // feedback KMP cambia l'altezza disponibile. L'editor vero
                        // conserva invece zoom/pan dell'utente come prima.
                        if (cw2.__cePlayerMode && cw2.CE) {
                            if (typeof cw2.__cePlayerFitViewport === 'function') {
                                cw2.__cePlayerFitViewport();
                            } else {
                                cw2.CE.zoomFit();
                            }
                        } else if (vpt && ow > 0 && oh > 0) {
                            vpt[4] += (w2 - ow) / 2;
                            vpt[5] += (h2 - oh) / 2;
                            fc2.setViewportTransform(vpt);
                            fc2.requestRenderAll();
                        } else if (cw2.CE) {
                            cw2.CE.zoomFit();
                        }
                    } catch (e) {}
                };
                window.__ceResizeTimer = setTimeout(doCeResize, 200);
            }
        }
    },
    'com.mico.learn.features.canvaseditor.webview.jsPickImageBase64' : () => {
        return new Promise(function(resolve) {
            var input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.style.display = 'none';
            document.body.appendChild(input);
            input.addEventListener('change', function() {
                if (!input.files || input.files.length === 0) { resolve(''); return; }
                var reader = new FileReader();
                reader.onload = function() {
                    var bytes = new Uint8Array(reader.result);
                    var binary = '';
                    for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
                    resolve(btoa(binary));
                };
                reader.onerror = function() { resolve(''); };
                reader.readAsArrayBuffer(input.files[0]);
                document.body.removeChild(input);
            });
            input.addEventListener('cancel', function() {
                document.body.removeChild(input);
                resolve('');
            });
            input.click();
        });
    },
    'com.mico.learn.features.canvaseditor.webview.jsDownloadBase64Png' : (base64Data, fileName) => {
        var byteChars = atob(base64Data);
        var byteArray = new Uint8Array(byteChars.length);
        for (var i = 0; i < byteChars.length; i++) byteArray[i] = byteChars.charCodeAt(i);
        var blob = new Blob([byteArray], { type: 'image/png' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = fileName;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(function(){ URL.revokeObjectURL(url); }, 5000);
    },
    'com.mico.learn.features.documenteditor.jsEvalInTtIframe' : (js) => {
        var iframe = document.getElementById('tt-editor-frame');
        if (iframe && iframe.contentWindow) {
            try { iframe.contentWindow.eval(js); }
            catch(e) { console.error('[TT eval]', e); }
        }
    },
    'com.mico.learn.features.documenteditor.jsCreateTtIframe' : (id, src) => {
        if (document.getElementById(id)) return;
        var iframe = document.createElement('iframe');
        iframe.id = id;
        iframe.src = src;
        iframe.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;border:none;' +
            'z-index:50;background:#ffffff;transition:opacity 0.2s;';
        iframe.allow = 'clipboard-write';
        // Append a <html>, NON a <body>: nella pagina wasm il body resta a 0x0.
        document.documentElement.appendChild(iframe);

        window.__ttMessageQueue = [];
        window.__ttMessageListener = function(e) {
            if (e.data && e.data.source === 'tiptap-editor') {
                try {
                    var wrap = { type: e.data.type, payload: e.data.payload == null ? null : e.data.payload };
                    window.__ttMessageQueue.push(JSON.stringify(wrap));
                } catch (err) {}
            }
        };
        window.addEventListener('message', window.__ttMessageListener);
        console.log('[TT iframe] created:', src);
    },
    'com.mico.learn.features.documenteditor.jsRemoveTtIframe' : (id) => {
        var iframe = document.getElementById(id);
        if (iframe) iframe.remove();
        if (window.__ttMessageListener) {
            window.removeEventListener('message', window.__ttMessageListener);
            window.__ttMessageListener = null;
        }
        window.__ttMessageQueue = [];
    },
    'com.mico.learn.features.documenteditor.jsSetTtIframeOverlay' : (id, overlayActive) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        if (overlayActive) {
            iframe.style.opacity = '0.15';
            iframe.style.pointerEvents = 'none';
        } else {
            iframe.style.opacity = '1';
            iframe.style.pointerEvents = 'auto';
        }
    },
    'com.mico.learn.features.documenteditor.jsDrainTtMessages' : () => {
        if (!window.__ttMessageQueue || window.__ttMessageQueue.length === 0) return '';
        var msgs = window.__ttMessageQueue.splice(0, window.__ttMessageQueue.length);
        return msgs.join(String.fromCharCode(0));
    },
    'com.mico.learn.features.documenteditor.jsSetTtIframeClipHole' : (id, x, y, w, h, r) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        if (w <= 0 || h <= 0) {
            // MAI 'none' e MAI un clip rettangolare pieno: solo un clip
            // NON-rettangolare toglie all'iframe il ruolo di occluder — senza,
            // il compositor Chrome culla il canvas wasm sotto e la fascia della
            // top bar resta non dipinta (collaudo 2026-07-18). Micro-buco 1px
            // nell'angolo: invisibile e senza effetti sui click.
            var iw = iframe.offsetWidth, ih = iframe.offsetHeight;
            iframe.style.clipPath = 'path("M 0 0 H ' + iw + ' V ' + ih + ' H 0 Z ' +
                'M 0 0 V 1 H 1 V 0 Z")';
            return;
        }
        var rect = iframe.getBoundingClientRect();
        var W = Math.ceil(rect.width), H = Math.ceil(rect.height);
        var rr = Math.min(r, w / 2, h / 2);
        var x2 = x + w, y2 = y + h;
        var p = 'M0 0H' + W + 'V' + H + 'H0Z' +
            'M' + (x + rr) + ' ' + y +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x + ' ' + (y + rr) +
            'V' + (y2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x + rr) + ' ' + y2 +
            'H' + (x2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x2 + ' ' + (y2 - rr) +
            'V' + (y + rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x2 - rr) + ' ' + y + 'Z';
        iframe.style.clipPath = 'path("' + p + '")';
    },
    'com.mico.learn.features.documenteditor.jsUpdateTtIframePosition' : (id, x, y, w, h) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        iframe.style.left = x + 'px';
        iframe.style.top = y + 'px';
        iframe.style.width = w + 'px';
        iframe.style.height = h + 'px';
        // Notifica all'editor che l'area è cambiata (ricalcolo paginazione tiptap).
        if (w > 0 && h > 0) {
            var size = w + 'x' + h;
            if (window.__ttLastSize !== size) {
                window.__ttLastSize = size;
                if (window.__ttResizeTimer) clearTimeout(window.__ttResizeTimer);
                window.__ttResizeTimer = setTimeout(function() {
                    window.__ttResizeTimer = null;
                    try {
                        var f = document.getElementById(id);
                        if (f && f.contentWindow && f.contentWindow.TiptapEditor &&
                            f.contentWindow.TiptapEditor.recalcLayout) {
                            f.contentWindow.TiptapEditor.recalcLayout();
                        }
                    } catch (e) {}
                }, 200);
            }
        }
    },
    'com.mico.learn.features.sheeteditor.jsEvalInSheetIframe' : (js) => {
        var iframe = document.getElementById('sheet-editor-frame');
        if (iframe && iframe.contentWindow) {
            try { iframe.contentWindow.eval(js); }
            catch(e) { console.error('[Sheet eval]', e); }
        }
    },
    'com.mico.learn.features.sheeteditor.jsCreateSheetIframe' : (id, src) => {
        if (document.getElementById(id)) return;
        var iframe = document.createElement('iframe');
        iframe.id = id;
        iframe.src = src;
        iframe.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;border:none;' +
            'z-index:50;background:#ffffff;transition:opacity 0.2s;';
        iframe.allow = 'clipboard-write';
        // Append a <html>, NON a <body>: nella pagina wasm il body resta a 0x0.
        document.documentElement.appendChild(iframe);

        var applyClip = function() {
            var iw = iframe.offsetWidth, ih = iframe.offsetHeight;
            if (iw > 0 && ih > 0) {
                iframe.style.clipPath = 'path("M 0 0 H ' + iw + ' V ' + ih + ' H 0 Z ' +
                    'M 0 0 V 1 H 1 V 0 Z")';
            }
        };
        applyClip();
        window.__sheetClipApply = applyClip;

        window.__sheetMessageQueue = [];
        window.__sheetMessageListener = function(e) {
            if (e.data && e.data.source === 'sheet-editor') {
                try {
                    var wrap = { type: e.data.type, payload: e.data.payload == null ? null : e.data.payload };
                    window.__sheetMessageQueue.push(JSON.stringify(wrap));
                } catch (err) {}
            }
        };
        window.addEventListener('message', window.__sheetMessageListener);
        console.log('[Sheet iframe] created:', src);
    },
    'com.mico.learn.features.sheeteditor.jsRemoveSheetIframe' : (id) => {
        var iframe = document.getElementById(id);
        if (iframe) iframe.remove();
        if (window.__sheetMessageListener) {
            window.removeEventListener('message', window.__sheetMessageListener);
            window.__sheetMessageListener = null;
        }
        window.__sheetMessageQueue = [];
        window.__sheetClipApply = null;
    },
    'com.mico.learn.features.sheeteditor.jsSetSheetIframeOverlay' : (id, overlayActive) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        if (overlayActive) {
            iframe.style.opacity = '0.15';
            iframe.style.pointerEvents = 'none';
        } else {
            iframe.style.opacity = '1';
            iframe.style.pointerEvents = 'auto';
        }
    },
    'com.mico.learn.features.sheeteditor.jsDrainSheetMessages' : () => {
        if (!window.__sheetMessageQueue || window.__sheetMessageQueue.length === 0) return '';
        var msgs = window.__sheetMessageQueue.splice(0, window.__sheetMessageQueue.length);
        return msgs.join(String.fromCharCode(0));
    },
    'com.mico.learn.features.sheeteditor.jsSetSheetIframeClipHole' : (id, x, y, w, h, r) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        if (w <= 0 || h <= 0) {
            var iw = iframe.offsetWidth, ih = iframe.offsetHeight;
            iframe.style.clipPath = 'path("M 0 0 H ' + iw + ' V ' + ih + ' H 0 Z ' +
                'M 0 0 V 1 H 1 V 0 Z")';
            return;
        }
        var rect = iframe.getBoundingClientRect();
        var W = Math.ceil(rect.width), H = Math.ceil(rect.height);
        var rr = Math.min(r, w / 2, h / 2);
        var x2 = x + w, y2 = y + h;
        var p = 'M0 0H' + W + 'V' + H + 'H0Z' +
            'M' + (x + rr) + ' ' + y +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x + ' ' + (y + rr) +
            'V' + (y2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x + rr) + ' ' + y2 +
            'H' + (x2 - rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + x2 + ' ' + (y2 - rr) +
            'V' + (y + rr) +
            'A' + rr + ' ' + rr + ' 0 0 0 ' + (x2 - rr) + ' ' + y + 'Z';
        iframe.style.clipPath = 'path("' + p + '")';
    },
    'com.mico.learn.features.sheeteditor.jsUpdateSheetIframePosition' : (id, x, y, w, h) => {
        var iframe = document.getElementById(id);
        if (!iframe) return;
        iframe.style.left = x + 'px';
        iframe.style.top = y + 'px';
        iframe.style.width = w + 'px';
        iframe.style.height = h + 'px';
        if (window.__sheetClipApply) window.__sheetClipApply();
        if (w > 0 && h > 0) {
            var size = w + 'x' + h;
            if (window.__sheetLastSize !== size) {
                window.__sheetLastSize = size;
                if (window.__sheetResizeTimer) clearTimeout(window.__sheetResizeTimer);
                window.__sheetResizeTimer = setTimeout(function() {
                    window.__sheetResizeTimer = null;
                    try {
                        var f = document.getElementById(id);
                        if (f && f.contentWindow && f.contentWindow.SheetEditor &&
                            f.contentWindow.SheetEditor.recalcLayout) {
                            f.contentWindow.SheetEditor.recalcLayout();
                        }
                    } catch (e) {}
                }, 200);
            }
        }
    },
    'com.mico.learn.core.ads.jsCreateAdContainers' : () => {
        // Container banner fisso in basso (sopra canvas WebGL con z-index alto)
        if (document.getElementById('mico-ad-banner')) return;

        var banner = document.createElement('div');
        banner.id = 'mico-ad-banner';
        banner.style.cssText = 'display:none;position:fixed;bottom:0;left:0;right:0;z-index:99999;text-align:center;background:transparent;pointer-events:auto;';
        document.body.appendChild(banner);
        console.log('[AdManager-Web] Ad containers created');
    },
    'com.mico.learn.core.ads.jsShowBannerAd' : () => {
        var container = document.getElementById('mico-ad-banner');
        if (!container) {
            console.warn('[AdBanner] Container not found, creating...');
            var c = document.createElement('div');
            c.id = 'mico-ad-banner';
            c.style.cssText = 'display:none;position:fixed;bottom:0;left:0;right:0;z-index:99999;text-align:center;background:transparent;pointer-events:auto;';
            document.body.appendChild(c);
            container = c;
        }

        // Pulisci contenuto precedente
        container.innerHTML = '';

        // Crea elemento AdSense
        var ins = document.createElement('ins');
        ins.className = 'adsbygoogle';
        ins.style.cssText = 'display:block;';
        ins.setAttribute('data-ad-client', 'ca-pub-7860520457548647');
        ins.setAttribute('data-ad-slot', '6321911168');
        ins.setAttribute('data-ad-format', 'auto');
        ins.setAttribute('data-full-width-responsive', 'true');

        container.appendChild(ins);
        container.style.display = 'block';

        // Push ad request
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            console.log('[AdBanner] AdSense banner pushed');
        } catch (e) {
            console.warn('[AdBanner] AdSense push failed:', e.message);
        }
    },
    'com.mico.learn.core.ads.jsHideBannerAd' : () => {
        var container = document.getElementById('mico-ad-banner');
        if (container) {
            container.style.display = 'none';
            container.innerHTML = '';
        }
    },
    'com.mico.learn.core.audio.jsCreateAudio' : (src) => { var a = new Audio(src); a.load(); return a; },
    'com.mico.learn.core.audio.jsPlayAudio' : (audio, vol) => { audio.volume = vol; audio.currentTime = 0; audio.play().catch(function(){}); },
    'com.mico.learn.core.ui.common.jsFetchBase64' : (url) => {
        return fetch(url).then(function(r) {
            if (!r.ok) return '';
            return r.arrayBuffer().then(function(buf) {
                var arr = new Uint8Array(buf);
                var s = '';
                for (var i = 0; i < arr.length; i++) {
                    s += String.fromCharCode(arr[i]);
                }
                return btoa(s);
            });
        });
    },
    'com.mico.learn.core.ui.common.jsSetBodyCursor' : (c) => { document.body.style.cursor = c },
    'com.mico.learn.core.ui.platform.jsCreateImageGrid' : 
    (filesJson, startIndex) => {
        return new Promise(async (resolve) => {
            try {
                const fileIndices = JSON.parse(filesJson);
                const files = window._lastPickedFiles;
                if (!files || fileIndices.length === 0) {
                    resolve('');
                    return;
                }

                // Load all images
                const images = [];
                for (const idx of fileIndices) {
                    const file = files[idx];
                    if (!file) continue;
                    const img = await new Promise((res, rej) => {
                        const i = new Image();
                        i.onload = () => res(i);
                        i.onerror = () => rej(new Error('Failed to load image'));
                        i.src = URL.createObjectURL(file);
                    });
                    images.push(img);
                }

                if (images.length === 0) {
                    resolve('');
                    return;
                }

                // Calculate grid layout
                const cols = Math.min(images.length, 2);
                const rows = Math.ceil(images.length / cols);
                const cellWidth = 800;
                const cellHeight = 600;
                const labelHeight = 30;
                const totalWidth = cols * cellWidth;
                const totalHeight = rows * (cellHeight + labelHeight);

                // Create canvas
                const canvas = document.createElement('canvas');
                canvas.width = totalWidth;
                canvas.height = totalHeight;
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, totalWidth, totalHeight);

                // Draw each image
                images.forEach((img, i) => {
                    const col = i % cols;
                    const row = Math.floor(i / cols);
                    const x = col * cellWidth;
                    const y = row * (cellHeight + labelHeight);

                    // Draw label
                    ctx.fillStyle = '#333333';
                    ctx.font = 'bold 20px sans-serif';
                    ctx.fillText('Immagine ' + (startIndex + i + 1), x + 10, y + 22);

                    // Draw image (fit within cell)
                    const scale = Math.min(cellWidth / img.width, cellHeight / img.height);
                    const dw = img.width * scale;
                    const dh = img.height * scale;
                    const dx = x + (cellWidth - dw) / 2;
                    const dy = y + labelHeight + (cellHeight - dh) / 2;
                    ctx.drawImage(img, dx, dy, dw, dh);

                    // Revoke object URL
                    URL.revokeObjectURL(img.src);
                });

                // Convert to JPEG base64
                const dataUrl = canvas.toDataURL('image/jpeg', 0.85);
                const base64 = dataUrl.split(',')[1];
                resolve(base64);
            } catch (e) {
                console.error('[ImageGrid] Error:', e);
                resolve('');
            }
        });
    }
    ,
    'com.mico.learn.core.ui.platform.jsRenderKaTeX' : 
    (latex) => {
        return new Promise((resolve) => {
            function doRender() {
                try {
                    const html = katex.renderToString(latex, {
                        throwOnError: false,
                        displayMode: false,
                        output: 'html'
                    });
                    // Strip HTML tags to extract Unicode math text rendered by KaTeX
                    const tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    // Remove hidden elements (like .katex-html aria-hidden spans
                    // when mathml is present, or vice versa). We want visible text only.
                    const hidden = tmp.querySelectorAll('[aria-hidden="true"]');
                    // KaTeX wraps output in .katex > .katex-mathml + .katex-html
                    // .katex-mathml is aria-hidden on screen but has good text;
                    // .katex-html has aria-hidden="true" when mathml is primary.
                    // We try .katex-html first (visual), fall back to full text.
                    const katexHtml = tmp.querySelector('.katex-html');
                    let text;
                    if (katexHtml) {
                        text = katexHtml.textContent || katexHtml.innerText || '';
                    } else {
                        text = tmp.textContent || tmp.innerText || '';
                    }
                    // Clean up excessive whitespace but keep meaningful spaces
                    text = text.replace(/\s+/g, ' ').trim();
                    resolve(text || latex);
                } catch (e) {
                    console.error('[KaTeX] render error:', e);
                    resolve(latex);
                }
            }

            // Check if KaTeX is already loaded
            if (typeof katex !== 'undefined') {
                doRender();
                return;
            }

            // Load KaTeX CSS
            if (!document.querySelector('link[href*="katex"]')) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'https://cdn.jsdelivr.net/npm/katex@0.16.21/dist/katex.min.css';
                link.crossOrigin = 'anonymous';
                document.head.appendChild(link);
            }

            // Load KaTeX JS
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.21/dist/katex.min.js';
            script.crossOrigin = 'anonymous';
            script.onload = () => { doRender(); };
            script.onerror = () => {
                console.error('[KaTeX] Failed to load KaTeX from CDN');
                resolve(latex);
            };
            document.head.appendChild(script);
        });
    }
    ,
    'com.mico.learn.features.personalmap.webview.ensureBridgeQueueInstalled' : () => {
        if (!window.__cmQueue) {
            window.__cmQueue = [];
            window.__cmHandler = (e) => {
                try {
                    if (e && e.data && e.data.__cm) {
                        const args = (e.data.args !== undefined) ? JSON.stringify(e.data.args) : '[]';
                        window.__cmQueue.push((e.data.method || '') + '|' + args);
                    }
                } catch (err) { console.error('[ConceptMapView] Bridge parse error:', err); }
            };
            window.addEventListener('message', window.__cmHandler);
            console.log('[ConceptMapView] Bridge queue installata');
        }
    },
    'com.mico.learn.features.personalmap.webview.popBridgeMessage' : () => {
        if (!window.__cmQueue || window.__cmQueue.length === 0) return null;
        return window.__cmQueue.shift();
    },
    'com.mico.learn.features.personalmap.webview.jsInitMap' : (iframe, mapJson, layout, editMode) => {
        const w = iframe.contentWindow;
        if (!w) return;
        let attempts = 0;
        const MAX_ATTEMPTS = 60;
        const tryInit = () => {
            if (typeof w.updateMap !== 'function') {
                if (attempts++ < MAX_ATTEMPTS) {
                    setTimeout(tryInit, 50);
                } else {
                    console.error('[ConceptMapView] updateMap non trovato dopo ' + MAX_ATTEMPTS + ' tentativi');
                }
                return;
            }
            try {
                w.updateMap(mapJson);
                if (typeof w.setLayout === 'function') w.setLayout(layout);
                if (typeof w.setEditMode === 'function') w.setEditMode(editMode);
                console.log('[ConceptMapView] init complete');
            } catch (e) {
                console.error('[ConceptMapView] init error:', e);
            }
        };
        tryInit();
    },
    'com.mico.learn.features.personalmap.webview.jsUpdateMap' : (iframe, mapJson) => {
        const w = iframe.contentWindow;
        if (w && typeof w.updateMap === 'function') {
            try { w.updateMap(mapJson); } catch (e) { console.error('updateMap', e); }
        }
    },
    'com.mico.learn.features.personalmap.webview.jsSetLayout' : (iframe, layout) => {
        const w = iframe.contentWindow;
        if (w && typeof w.setLayout === 'function') {
            try { w.setLayout(layout); } catch (e) { console.error('setLayout', e); }
        }
    },
    'com.mico.learn.features.personalmap.webview.jsSetEditMode' : (iframe, editMode) => {
        const w = iframe.contentWindow;
        if (w && typeof w.setEditMode === 'function') {
            try { w.setEditMode(editMode); } catch (e) { console.error('setEditMode', e); }
        }
    },
    'com.mico.learn.features.personalmap.webview.jsCreateConceptMapIframe' : () => {
        const iframe = document.createElement('iframe');
        iframe.src = 'concept-map/index.html';
        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.display = 'block';
        iframe.setAttribute('allow', 'fullscreen');
        iframe.addEventListener('load', () => {
            try {
                const w = iframe.contentWindow;
                if (!w) return;
                w.AndroidBridge = {
                    onWebViewReady: () => parent.postMessage({__cm:true,method:'onWebViewReady'}, '*'),
                    onNodeClick: (id) => parent.postMessage({__cm:true,method:'onNodeClick',args:[id]}, '*'),
                    onNodeDoubleClick: (id) => parent.postMessage({__cm:true,method:'onNodeDoubleClick',args:[id]}, '*'),
                    onNodePositionChange: (id,x,y) => parent.postMessage({__cm:true,method:'onNodePositionChange',args:[id,x,y]}, '*'),
                    onReadyForCapture: () => parent.postMessage({__cm:true,method:'onReadyForCapture'}, '*'),
                    onAddChildNode: (id) => parent.postMessage({__cm:true,method:'onAddChildNode',args:[id]}, '*'),
                    onDeleteNode: (id) => parent.postMessage({__cm:true,method:'onDeleteNode',args:[id]}, '*'),
                    onNodeResize: (id,wd) => parent.postMessage({__cm:true,method:'onNodeResize',args:[id,wd]}, '*'),
                    onWorkspaceClick: () => parent.postMessage({__cm:true,method:'onWorkspaceClick'}, '*'),
                    requestKeyboard: () => {},
                    hideKeyboard: () => {},
                    log: (msg) => console.log('[CM Bridge] ' + msg),
                    showToast: (msg) => console.log('[CM Toast] ' + msg),
                    onExportComplete: (b64,wd,h) => parent.postMessage({__cm:true,method:'onExportComplete',args:[b64,wd,h]}, '*'),
                    onExportTiles: (json) => parent.postMessage({__cm:true,method:'onExportTiles',args:[json]}, '*'),
                    onExportError: (err) => parent.postMessage({__cm:true,method:'onExportError',args:[err]}, '*'),
                    onSVGExportComplete: (svg) => parent.postMessage({__cm:true,method:'onSVGExportComplete',args:[svg]}, '*')
                };
                console.log('[ConceptMapView] AndroidBridge polyfill iniettato');
            } catch (e) {
                console.error('[ConceptMapView] Errore iniezione polyfill:', e);
            }
        });
        return iframe;
    },
    'com.mico.learn.features.personalmap.webview.jsEvalInIframe' : (iframe, js) => {
        const w = iframe.contentWindow;
        if (!w) return;
        try { (new w.Function(js))(); } catch (e) { console.error('eval failed', e); }
    },
    'com.mico.learn.features.personalmap.webview.jsDownloadBase64' : (base64Data, fileName, mimeType) => {
        var base64Clean = base64Data.indexOf('base64,') >= 0 ? base64Data.split('base64,')[1] : base64Data;
        var byteChars = atob(base64Clean);
        var byteArray = new Uint8Array(byteChars.length);
        for (var i = 0; i < byteChars.length; i++) {
            byteArray[i] = byteChars.charCodeAt(i);
        }
        var blob = new Blob([byteArray], { type: mimeType });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function() { URL.revokeObjectURL(url); }, 5000);
    },
    'com.mico.learn.features.personalmap.webview.jsDownloadText' : (textData, fileName, mimeType) => {
        var blob = new Blob([textData], { type: mimeType });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function() { URL.revokeObjectURL(url); }, 5000);
    },
    'com.mico.learn.features.personalmap.webview.jsReassembleTilesAndDownload' : (tilesJson, fileName) => {
        try {
            var data = JSON.parse(tilesJson);
            var finalWidth = data.finalWidth || data.totalWidth;
            var finalHeight = data.finalHeight || data.totalHeight;
            var tiles = data.tiles;

            var canvas = document.createElement('canvas');
            canvas.width = finalWidth;
            canvas.height = finalHeight;
            var ctx = canvas.getContext('2d');

            var loaded = 0;
            var total = tiles.length;

            tiles.forEach(function(tile) {
                var img = new Image();
                img.onload = function() {
                    ctx.drawImage(img, tile.x, tile.y);
                    loaded++;
                    if (loaded === total) {
                        canvas.toBlob(function(blob) {
                            var url = URL.createObjectURL(blob);
                            var a = document.createElement('a');
                            a.href = url;
                            a.download = fileName;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                            setTimeout(function() { URL.revokeObjectURL(url); }, 5000);
                        }, 'image/png');
                    }
                };
                img.src = tile.data;
            });
        } catch(e) {
            console.error('Tiles reassembly error:', e);
        }
    },
    'com.mico.learn.features.personalmap.webview.jsLoadImageFromFile' : (file, id) => {
        var img = new Image();
        img.id = id;
        img.style.display = 'none';
        document.body.appendChild(img);
        var reader = new FileReader();
        reader.onload = function(e) {
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    },
    'com.mico.learn.features.personalmap.webview.jsCropImage' : (id, scale, offsetX, offsetY, outputSize) => {
        var img = document.getElementById(id);
        if (!img || !img.complete) return null;

        var canvas = document.createElement('canvas');
        canvas.width = outputSize;
        canvas.height = outputSize;
        var ctx = canvas.getContext('2d');

        // Sfondo bianco
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, outputSize, outputSize);

        // Calcola dimensioni scalate
        var scaledW = img.naturalWidth * scale;
        var scaledH = img.naturalHeight * scale;

        // Centro dell'area di crop
        var cx = outputSize / 2;
        var cy = outputSize / 2;

        // Posizione dell'immagine
        var drawX = cx - (scaledW / 2) + offsetX;
        var drawY = cy - (scaledH / 2) + offsetY;

        ctx.drawImage(img, drawX, drawY, scaledW, scaledH);

        return canvas.toDataURL('image/jpeg', 0.85);
    },
    'com.mico.learn.features.personalmap.webview.jsCleanupCropImage' : (id) => {
        var img = document.getElementById(id);
        if (img) img.remove();
    },
    'syncFetchText' : (url) => { var xhr = new XMLHttpRequest(); xhr.open('GET', url, false); xhr.send(); return xhr.status === 200 ? xhr.responseText : ''; }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    